export default __webpack_public_path__ + "static/media/kitchen3-after1-768w.38f4671c.webp";